import React from "react";

const DashboardContext = React.createContext();

const DashboardContextProvider = ({ children }) => {
	const [dueReportsCount, setDueReportsCount] = React.useState({});
	const value = React.useMemo(
		() => ({ dueReportsCount, setDueReportsCount }),
		[dueReportsCount, setDueReportsCount]
	);

	return (
		<DashboardContext.Provider value={value}>
			{children}
		</DashboardContext.Provider>
	);
};

export { DashboardContext, DashboardContextProvider };
